export default {
  SITE: 'site',
  EDITOR: 'editor',
  PREVIEW: 'preview',
  DASHBOARD: 'dashboard',
  STANDALONE: 'standalone',
};



// WEBPACK FOOTER //
// ./src/shared/constants/view-modes.js